import { handleClasses } from "./handle-classes";

export const toggleDialog = (
  target: Element | HTMLElement | null,
  isVisible: boolean,
  classes: { add: string; remove: string }[] = [],
) => {
  if (!target) return;

  target.classList.add(isVisible ? "visible" : "invisible");
  target.classList.remove(isVisible ? "invisible" : "visible");
  target.setAttribute("aria-hidden", String(!isVisible));

  if (classes.length) {
    handleClasses(target, classes);
  }
};
